export class StatusArchivage {
    constructor(
        public enCours?: Boolean,
        public dateDeLancement?: Date,
) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/archive/statusArchivage.model.ts